import React, { Suspense, useContext } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Loading from "./components/UI/Loading";
import Layout from "./containers/Layout";
import { AuthContext } from "./API/AuthContext";

const HomePage = React.lazy(() => import("./pages/HomePage"));
const MenuPage = React.lazy(() => import("./pages/MenuPage"));
const AboutPage = React.lazy(() => import("./pages/AboutPage"));
const ContactPage = React.lazy(() => import("./pages/ContactPage"));
const SingleFoodPage = React.lazy(() => import("./pages/SingleFoodPage"));
const LoginPage = React.lazy(() => import("./pages/Auth/LoginPage"));
const RegisterPage = React.lazy(() => import("./pages/Auth/RegisterPage"));
const ProfilePage = React.lazy(() => import("./pages/ProfilePage"));
const OrderPage = React.lazy(() => import("./pages/OrderPage"));

function App() {
  const [isAuth, , currentUser] = useContext(AuthContext);

  return (
    <div className="App">
      <Router>
        <Suspense fallback={<Loading />}>
          <Switch>
            <Route exact path="/register" component={RegisterPage} />
            <Route exact path="/login" component={LoginPage} />
            <Layout>
              <Route exact path="/" component={HomePage} />
              <Route path="/menu" component={MenuPage} />
              <Route path="/about" component={AboutPage} />
              <Route path="/contact" component={ContactPage} />
              <Route path="/meal/:slug" component={SingleFoodPage} />

              <Route
                exact
                path="/me"
                render={() =>
                  isAuth && currentUser ? (
                    <ProfilePage />
                  ) : (
                    <Redirect to="/login" />
                  )
                }
              />

              <Route
                exact
                path="/me/order/:id"
                render={() =>
                  isAuth && currentUser ? (
                    <OrderPage />
                  ) : (
                    <Redirect to="/login" />
                  )
                }
              />
            </Layout>
          </Switch>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
